module.exports = __webpack_public_path__ + "img/Lion_Logo-02 1.3cedb28b.png";